import { render } from "./ComHeader.vue?vue&type=template&id=062194ac&scoped=true"
import script from "./ComHeader.vue?vue&type=script&lang=js"
export * from "./ComHeader.vue?vue&type=script&lang=js"

import "./ComHeader.vue?vue&type=style&index=0&id=062194ac&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-062194ac"]])

export default __exports__